import memsData from "../memsData"
import MemeData from "../memsData"



export default function MemeButton(props) {

    return (
        <div className="button-container">
            <button type="button" onClick={props.handleClick} className="meme-button">Get a new meme image</button>
        </div>
    )
}

